<template>
    <div class="full">
        <div class="main">
            <div class="header PersonMess">
                <div class="top">
                    <ul>
                        <li><img src="@/assets/image/message/tou.png" width="93" height="124"> </li>
                        <li>
                            <p>姓名：{{user.user_name||'XXX'}}</p>
                            <p>性别：{{user.sex||'X'}}</p>
                            <p>准考证号：{{user.exam_no || '111111111111111'}}</p>
                            <p>证件号码：{{user.user_id_no || '111111111111111111'}}</p>
                            <!--<p>报名序号：{{user.user_signup_no || 'XXXXXXXXX'}}</p>-->
                            <p>机位号：111</p>
                        </li>
                        <li>
                            <p>考试类型：正常考试</p>
                            <p>考试时间：{{exam_time}}分钟</p>
                            <p class="ok" style="padding-right: 0px;" v-show="paper_progress == 100">试卷加载：已加载</p>
                        </li>
                        <li class="four">
                            <input type="button" :value="'倒计时：0:0:'+paper_djs_time" class="action" id="mybtn" v-show="paper_progress == 100">
                            <div class="bar" style="display: block;">
                                <p :style="'width:'+paper_progress+'%;'"></p><label class="num">{{paper_progress}}%</label>
                            </div>
                            <span class="jzed" style="display: inline;">正在进行加载，已经完成<label class="num">100%</label></span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="down">
                <ul class="change">
                    <li v-for="(item,index) in article" :key="index" :class="content_show_index == index?'current':''" @click="content_show_index = index">{{item.article_title}}</li>
                </ul>
                <div class="content">
                    <div v-for="(item,index) in article" :key="index" v-html="item.article_content" v-show="content_show_index == index"></div>
                </div>
                <div class="action read" @click="read" :disabled="is_read">我已阅读</div>
            </div>
        </div>
    </div>
</template>
    
<script>
export default {
    name: '',
    components: {
    },
    data() {
        return {
            icon: true,
            btn: ['确定'],
            show: false,
            msg: "",

            paper_progress: 0, //试卷加载进度，百分比
            paper_djs_time: 15, //按钮倒计时,秒
            is_read: false, //是否阅读
            content_show_index: 0, //当前显示的文章下标
            article: [], //文章列表

            exam_time: 120, //考试时间，分钟 基础
            //exam_time:180,//考试时间，分钟 实务
        }
    },
    computed: {
        user() {
            return this.$store.state.user;
        }
    },
    created() {
        this.gerArticle();
        this.barProgress();
        
        this.exam_time = this.$store.state.exam.cur_subject.duration || 90;
    },
    methods: {
        gerArticle() {
            this.$req.post("article/select", {classify:3}).then(res => {
                if (res.flag == 1) {
                    this.article = res.data.articles;
                    
                }
            })
        },
        //点击我已经阅读
        read() {
            this.is_read = true;
            if (this.paper_djs_time == 0) {
                this.$router.push({
                    name: "Exam"
                    ,params:{project_code:this.$store.state.project.project_code}
                });
            }
        },

        //试卷虚拟加载进度
        barProgress() {
            this.paper_progress = this.paper_progress + 1;
            let this_ = this;
            if (this.paper_progress < 100) {
                setTimeout(function () {
                    this_.barProgress();
                }, 10);
            } else {
                //加载完试卷启动倒计时
                setTimeout(this.countdown(), 1000);
            }

        },

        //按钮倒计时，时间到了如果已经点击我约阅读，直接进入考试，如果未点，提示点击
        countdown() {

            this.paper_djs_time = this.paper_djs_time - 1;
            let this_ = this;
            if (this.paper_djs_time > 0) {
                setTimeout(function () {
                    this_.countdown();
                }, 1000);
            } else {
                this.setExamEndTime();
                if (this.is_read) {
                    this.$router.push({
                        name: "Exam"
                        ,params:{project_code:this.$store.state.project.project_code}
                    });
                } else {
                    this.$tip({text:"考试已经开始倒计时，请尽快阅读考场规则并点击“我已阅读”按钮，进入作答界面。"})
                }

            }
        },
        /*  设置结束考试时间，考试时间从倒计时结束那一刻开始算。
            在考试页面exam:获取考试时间从这个时间里计算
        */
        setExamEndTime() {
            let cur_time = new Date().getTime();
            let end_time = cur_time + this.exam_time * 60 * 1000;

            let exam = this.$store.state.exam;
            exam.exam_end_time = end_time;

            this.$store.commit("exam", exam);

        },

        
    },
}
</script>

<style lang='scss' scoped src="../assets/css/article.scss"></style>
    